import { useApi } from '@/api';
import { Link, TableSkeleton } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  useTableProps,
  PercentageValue,
  formatNumber,
  DataTable
} from '@blockanalitica/ui';

export default function AuctionParametersTable() {
  const { pagination, sorting } = useTableProps({
    pageSize: 5,
    filtersDebounceTime: 50,
    initialFilters: { active: '0' }
  });

  const [data, error] = useApi({
    url: `/ilk-parameters/auction/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Name',
        getCell: (row) => row.ilk
      },
      {
        header: 'Chop',
        getCell: (row) => <PercentageValue value={row.chop} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Hole',
        getCell: (row) => formatNumber(row.hole),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Buf',
        getCell: (row) => <PercentageValue value={row.buf} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Tail',
        getCell: (row) =>
          formatNumber(row.tail, { notation: 'standard' }) + ' sec',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Cusp',
        getCell: (row) => <PercentageValue value={row.cusp} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Chip',
        getCell: (row) => <PercentageValue value={row.chip} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Tip',
        getCell: (row) => formatNumber(row.tip),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Step',
        getCell: (row) => formatNumber(row.step) + ' sec',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Cut',
        getCell: (row) => <PercentageValue value={row.cut} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Liquidatable',
        getCell: (row) => (row.stopped ? 'No' : 'Yes'),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        rowLinkProps={{
          to: (row) => `/collateral/${row.group}/${row.ilk}/parameters`,
          // @ts-ignore
          linkComponent: Link
        }}
        getKey={(row) => row.ilk}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton rows={5} />;
}
